/* start - flights_split_bounds_us */
import { UIFlightData } from "@flights/types";
import React from "react";
import { useFlightCardLuggageController } from "./FlightCardLuggage/useFlightCardLuggage.controller";
import { getCampaignBadgesConfig } from "../../../../../utils/flightCampaignConfig";
import { Stack } from "@bookingcom/bui-react";
import { useSplitBoundsCondition } from "../../../../../utils/experiments/funnel/flights_split_bounds_us";

type Props = {
  flight: UIFlightData;
  boundsVariant?: "outbound" | "inbound";
  campaignBadges: ReturnType<typeof getCampaignBadgesConfig>;
  luggageComponent?: React.ReactNode;
  badgesComponent?: React.ReactNode;
};

const CardSplitBoundsLuggageAndBadgesRendererDesktop = ({
  flight,
  boundsVariant,
  campaignBadges,
  luggageComponent,
  badgesComponent
}: Props) => {
  const { isSplitBounds } = useSplitBoundsCondition();
  const { luggageList } = useFlightCardLuggageController(flight, isSplitBounds);

  const showLuggage = boundsVariant === "inbound" && luggageList.length > 0;
  const showBadges = campaignBadges.length > 0;

  if (!showLuggage && !showBadges) {
    return null;
  }

  if (!isSplitBounds) {
    return null;
  }

  return (
    <Stack direction="row" gap={0} alignItems="center" mixin={{ marginBlockStart: 2 }}>
      {showLuggage && luggageComponent}
      {showBadges && badgesComponent}
    </Stack>
  );
};

export default CardSplitBoundsLuggageAndBadgesRendererDesktop;
/* end - flights_split_bounds_us */
